import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { jwtDecode } from 'jwt-decode';
@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  private apiUrl = environment.apiUrl; 

  constructor(private http: HttpClient) {}
  
  // Login method
  login(userName:any,password:any): Observable<any> {
    return this.http.post(`${this.apiUrl}/UserAuth/Login`, {userName,password},environment.options);
  }

  // Register method
  register(body:any): Observable<any> {
    return this.http.post(`${this.apiUrl}/UserAuth/Register`, body,environment.options);
  }

  getUserById(id:string){
    return this.http.get(`${this.apiUrl}/UserAuth/GetUser/ID?ID=${id}`,environment.options);
  }

  updateUserDetails(body:any,id:string){
    return this.http.put(`${this.apiUrl}/UserAuth/UpdateUser?ID=${id}`,body,environment.options);
  }

  changePassword(body:any,id:string){
    return this.http.put(`${this.apiUrl}/UserAuth/ResetPassword?ID=${id}`,body,environment.options);
  }
  isLogedIn(){
    const user = sessionStorage.getItem("user");
    if(user){
      return true;
    }else{
      return false;
    }
  }

  getUserSession(){
    const userSessoion = sessionStorage.getItem("user") || "";
    if(userSessoion != ""){

      const user = JSON.parse(userSessoion);
      if(user){
        user.tokenValue = jwtDecode(user.token);
        return user;
      }
    }
    return null;
  }
}
